<svg
  width="6"
  height="6"
  viewBox="0 0 6 6"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
  class={$$props.class}
>
  <path d="M0 0L6 0L6 6L0 0Z" fill="#0F0F0F" />
</svg>
